import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["className", "selectRef", "size"];
import React from 'react';
import classNames from 'classnames';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';

var SelectBox = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SelectBox, _React$Component);

  function SelectBox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SelectBox.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        selectRef = _this$props.selectRef,
        size = _this$props.size,
        attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var classes = classNames(className, 'select-box', size ? "select-box--" + size : '');
    return /*#__PURE__*/React.createElement(Select, _extends({
      ref: selectRef,
      classNamePrefix: "select-box",
      role: "listbox",
      className: classes,
      closeMenuOnSelect: !attributes.isMulti,
      components: makeAnimated()
    }, attributes));
  };

  return SelectBox;
}(React.Component);

export { SelectBox as default };